<script setup lang="ts">

</script>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'GoldFrame',

    data(): {
        corner: {
            width: number
            height: number
        },
        lineHorizontal: {
            width: number
            height: number
        },
        lineVertical: {
            width: number
            height: number
        },
    } {
        return {
            corner: {
                width: 120,
                height: 90,
            },

            lineHorizontal: {
                width: 120,
                height: 90,
            },

            lineVertical: {
                width: 120,
                height: 90,
            },
        }
    },

    props: {
        offset: {
            type: Number,
            required: true,
        },

        sizeModifier: {
            type: Number,
            default: 1,
        },
    },
})
</script>

<template>
    <div class="frameBox noselect">
        <div
            :style="{
                backgroundImage: `url('/img/page/landing/registration/pass/white_pass/frame1/top.png')`,
                top: `${-offset}px`,
                left: `${(corner.width * sizeModifier) - offset}px`,
                right: `${(corner.width * sizeModifier) - offset}px`,
            }"
            class="frame top horizontal"
        />

        <div
            :style="{
                backgroundImage: `url('/img/page/landing/registration/pass/white_pass/frame1/right.png')`,
                right: `${-offset}px`,
                top: `${(corner.height * sizeModifier) - offset}px`,
                bottom: `${(corner.height * sizeModifier) - offset}px`,
            }"
            class="frame right vertical"
        />

        <div
            :style="{
                backgroundImage: `url('/img/page/landing/registration/pass/white_pass/frame1/bottom.png')`,
                bottom: `${-offset}px`,
                left: `${(corner.width * sizeModifier) - offset}px`,
                right: `${(corner.width * sizeModifier) - offset}px`,
            }"
            class="frame bottom horizontal"
        />

        <div
            :style="{
                backgroundImage: `url('/img/page/landing/registration/pass/white_pass/frame1/left.png')`,
                left: `${-offset}px`,
                top: `${(corner.height * sizeModifier) - offset}px`,
                bottom: `${(corner.height * sizeModifier) - offset}px`,
            }"
            class="frame left vertical"
        />


        <div
            :style="{
                backgroundImage: `url('/img/page/landing/registration/pass/white_pass/frame1/top-right.png')`,
                top: `${-offset}px`,
                right: `${-offset}px`,
            }"
            class="frame corner top-right"
        />

        <div
            :style="{
                backgroundImage: `url('/img/page/landing/registration/pass/white_pass/frame1/bottom-right.png')`,
                bottom: `${-offset}px`,
                right: `${-offset}px`,
            }"
            class="frame corner bottom-right"
        />

        <div
            :style="{
                backgroundImage: `url('/img/page/landing/registration/pass/white_pass/frame1/bottom-left.png')`,
                bottom: `${-offset}px`,
                left: `${-offset}px`,
            }"
            class="frame corner bottom-left"
        />

        <div
            :style="{
                backgroundImage: `url('/img/page/landing/registration/pass/white_pass/frame1/top-left.png')`,
                top: `${-offset}px`,
                left: `${-offset}px`,
            }"
            class="frame corner top-left"
        />
    </div>
</template>

<style scoped lang="scss">
.frameBox {
    position: absolute;
    pointer-events: none;
    z-index: 1000;
    width: 100%;
    height: 100%;
}

.frame {
    position: absolute;

    background-size: 100% 100%;

    &.horizontal {
        height: v-bind('(lineHorizontal.height * sizeModifier) + "px"');
    }
    &.vertical {
        width: v-bind('(lineVertical.width * sizeModifier) + "px"');
    }

    &.corner {
        width: v-bind('(corner.width * sizeModifier) + "px"');
        height: v-bind('(corner.height * sizeModifier) + "px"');
    }
}
</style>
